import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from '../../i18n';
import { activityOptions } from '../ActivityUtils/activityOptions';

const ActivityModal = ({ show, onHide, onSelectActivity }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('activitySelector.selectActivityType')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="activity-selection">
          {activityOptions.map(({ type, key, icon, color }) => (
            <Button
              key={key}
              onClick={() => onSelectActivity(type)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundColor: color,
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                padding: '10px',
                marginBottom: '10px',
                borderRadius: '8px',
                border: 'none',
                width: '100%',
                textAlign: 'left'
              }}
            >
              <img
                src={icon}
                alt={t(`activityLabels.${key}`)}
                style={{ width: '30px', height: '30px', marginRight: '15px' }}
              />
              {t(`activityLabels.${key}`)}
            </Button>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActivityModal;